import { CockpitFilterConfig } from "../models/cockpit-filter-config.model";

export const MPR_FILTER_CONFIG: CockpitFilterConfig[] = [
  {
    path: 'mpr',
    defaultFilters: [],
    keepFilters: [],
  }
];

